module.exports = __webpack_public_path__ + "static/media/TALOGO.f0b849f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TALOGO.png
// module id = 799
// module chunks = 0